<template>
  <div
    :class="{focused: !disableFocus && selected,
      focused: selectOnHover && isHovering,
     'human-item_bordered': bordered,
     'human-item_allow-focus': !disableFocus}"
    @mouseover="isHovering = true"
    @mouseout="isHovering = false"
    class="human-item">
    <div
      class="human-container">
      <profile-image
        :src="user.avatar_url"
        :user="user"
        class="human-item__profile-image"/>
      <div class="human-item__info">
        <div class="human-item__name">
          {{ $getUserName(user) }}
        </div>
        <div v-if="showPhone" class="human-item__phone">
          {{user.phone | formatPhone}}
        </div>
        <div v-if="!showMoneyInput && showMoney" class="human-item__money">
          {{moneyAmount.toFixed(2)}}
        </div>
        <div v-if="showMoneyInput && showMoney" class="human-item__money-form">
          <input v-model="money"
                 @input="$emit('changeMoney', {amount: money, phone: user.phone})"
                 placeholder="0.00"
                 type="number"
          >
        </div>
      </div>
    </div>
    <delete-human-button
      v-if="showDeleteButton"
      @deleteHuman="deleteHuman(user)"
      class="delete-human-button"
    />
  </div>
</template>

<script>
import DeleteHumanButton from '../DeleteHumanButton/DeleteHumanButton';
import ProfileImage from '../ProfileImage/ProfileImage';

export default {
  name: 'AddParticipantsUserItem',
  components: {
    DeleteHumanButton,
    ProfileImage,
  },
  data() {
    return {
      money: '',
      isHovering: false,
    };
  },
  props: {
    bordered: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    moneyAmount: {
      type: Number,
      default: 0,
    },
    showMoneyInput: {
      type: Boolean,
      default: false,
    },
    showMoney: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: true,
    },
    selectOnHover: {
      type: Boolean,
      default: false,
    },
    showDeleteButton: {
      type: Boolean,
      default: true,
    },
    disableFocus: {
      type: Boolean,
      default: false,
    },
    showPhone: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    deleteHuman(user) {
      const { phone } = user;
      this.$emit('changeMoney', { money: 0, phone });
      this.$emit('deleteUser', user);
    },
  },
};
</script>

<style scoped>
  .human-item {
    display: flex;
    box-sizing: border-box;
    padding: 9px 0;
    font-size: 1rem;
    outline: none;
  }

  .human-container {
    display: flex;
    flex: 1;
  }

  .human-item_allow-focus {
    cursor: pointer;
  }

  .human-item_bordered {
    border-bottom: 1px solid #E3E9F5;
  }

  .human-item__profile-image {
    align-self: center;
  }

  .focused .human-item__profile-image {
    box-shadow: 0 1px 6px rgba(41, 121, 255, 0.61)
  }

  .human-item__name {
    color: var(--text-main-color);
  }

  .human-item__info {
    flex: 1;
    text-align: left;
    margin: 0 10px 0 10px;
  }
  .human-item__phone {
    font-size: 12px;
    font-weight: normal;
    color: rgba(72, 82, 140, 0.6);
  }
  .human-item__money {
    flex: 1;
    text-align: right;
  }

  .delete-human-button {
    margin-left: auto;
  }
</style>
